const { jsPDF } = window.jspdf;

const generatePdf = () => {
  const schedaTecnicaHTML = document.querySelector(".schedatecnica");

  if (!schedaTecnicaHTML) return;
  const { documentName } = schedaTecnicaHTML.dataset;

  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', lineHeight: 1.5 });

  doc.html(schedaTecnicaHTML, {
    autoPaging: "text",
    width: 180,
    height: 267,
    margin: [15, 15],
    windowWidth: 800,
    html2canvas: {
      windowWidth: 800,
    },
    callback: (doc) => {
      const table = document.querySelector("#variants-table");
      if (table) {
        const { width, height } = schedaTecnicaHTML.getBoundingClientRect();
        const endY = (180 / width) * height + 60;
        const page = Math.floor(endY / 297) + 1;
        const startY = endY % 297;
        if (page > doc.getNumberOfPages()) {
          doc.addPage();
        }
        doc.setPage(page);
        doc.autoTable({
          html: table,
          startY,
          margin: { left: 15, right: 15 },
          theme: "grid",
          pageBreak: "avoid",
          showHead: "firstPage",
          headStyles: {
            fillColor: [51, 96, 76],
          },
        });
      }
      doc.save(documentName || "product.pdf");
    },
  });
};

document
  .querySelector(".download-scheda-tecnica-btn")
  ?.addEventListener("click", generatePdf);
